import {injectable} from "inversify";
import {QueryFilterFormInterface} from "@/modules/vue/interfaces";

@injectable()
export class PlayerQueryFilterForm implements QueryFilterFormInterface {
  getDefaultForm(): { [p: string]: any } {
    return {
      skill: [1, 100],
      age: [15, 40],
      positions: [],
      knownTalentsOnly: false,
      canAffordOnly: false,
      talent: [1, 7],
    };
  }
}